import { render, staticRenderFns } from "./OCRlist.vue?vue&type=template&id=12b613b3&scoped=true&"
import script from "./OCRlist.vue?vue&type=script&lang=ts&"
export * from "./OCRlist.vue?vue&type=script&lang=ts&"
import style0 from "./OCRlist.vue?vue&type=style&index=0&id=12b613b3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b613b3",
  null
  
)

export default component.exports